<script lang="ts" setup>
import type { Notification } from '~/types/cart'

defineProps<{
  notification: Notification
}>()

const statusClasses = {
  error: 'bg-main-red text-white',
  help: 'bg-main-blue text-white',
  info: 'bg-white text-main-dark',
  success: 'bg-main-green text-white',
  warning: 'bg-main-yellow text-black',
}
</script>

<template>
  <div
    class="rounded-xl p-3 text-sm"
    :class="statusClasses[notification.status]"
  >
    <HtmlArea v-if="notification.html" :plain-html="notification.html" />
    <pre v-else-if="notification.text" class="pre-wrap">{{ notification.text }}</pre>
  </div>
</template>
